import fetch from 'isomorphic-fetch';
import config from '../../configs/client';
import GeneralStore from 'stores/GeneralStore';
import CategoryStore from 'stores/CategoryStore';
import InstantBookingStore from 'stores/InstantBookingStore';
import UserStore from 'stores/UserStore';
import { translate as t } from 'lang';
import ActionCreators from '../actions/ActionCreators'

const DELAY_FETCH_TIME = 600;

// One minute in milli seconds
const TIME_LIMIT_SEND_RESTORE_PASSWORD_SMS = 60000;

var timerId = null;
var restorePasswordSMSlastTime = null;

function delay(time) {

    if (timerId !== null) {
        clearTimeout(timerId);
    }

    return new Promise((resolve) => {
        timerId = setTimeout(resolve, time);
    });
}

export function validate() {
    var request = GeneralStore.getNormalizedState();

    // Проверка наличия данных в stuff
    console.log('Stuff in request:', request.stuff);
    if (!request.stuff || request.stuff.length === 0) {
        console.error('❗ Stuff не попал в request!');
    }

    return fetch(`${config.api.vezetvsem.url}/orders/validation`, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            request: request,
        }),
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function submit() {
    const request = GeneralStore.getNormalizedState()

    return ActionCreators.calibrateNormalizedLocations(request.locations, true)
        .then((calibratedLocations) => {

            if (calibratedLocations) {
                request.locations = calibratedLocations;
            }

            return fetch(`${config.api.vezetvsem.url}/orders`, {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-API-KEY': config.api.vezetvsem.key,
                },
                body: JSON.stringify({
                    request: request,
                }),
                credentials: 'same-origin',
            })
                .then(response => response.json())
                .then(json => json.response)
                .catch(error => console.error(error));
        });
}

export function submitUpdate() {
    var request = GeneralStore.getNormalizedState();
    var orderId = GeneralStore.getOrderId();

    if (!orderId || !UserStore.hasAutologinHash()) {
        return new Promise((resolve, reject) => {
            reject(t('YOU_HAVE_NO_RIGHTS_TO_EDIT_ORDER'));
        });
        // request.user = {
        //     'autologin_hash': '09b7e3fbdb439ba6f2b10f54e2bca731'
        // };
    }

    return ActionCreators.calibrateNormalizedLocations(request.locations)
        .then((calibratedLocations) => {

            if (calibratedLocations) {
                request.locations = calibratedLocations;
            }

            return fetch(`${config.api.vezetvsem.url}/orders/${orderId}`, {
                method: 'put',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-API-KEY': config.api.vezetvsem.key,
                },
                body: JSON.stringify({
                    request: request,
                }),
                credentials: 'same-origin',
            })
                .then(response => response.json())
                .then(json => json.response)
                .catch(error => console.error(error));
        });
}

export function getDadata(query, countryId = 1, count = 10) {
    return fetch(`${config.api.vezetvsem.url}/geo/dadata?q=${encodeURIComponent(query)}&country_id=${countryId}&limit=${count}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .catch(error => console.error(error));
}

export function getDadataDelay(query, countryId = 1, count = 10) {
    return delay(DELAY_FETCH_TIME).then(() => {
        return getDadata(query, countryId, count = 10);
    });
}

export function getAddressHints(query, countryId = 1, provider = '2gis', count = 10) {
    return fetch(`${config.api.vezetvsem.url}/geo/address/hints?q=${encodeURIComponent(query)}&country_id=${countryId}&limit=${count}&provider=${provider}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .catch(error => console.error(error));
}

export function getAddressHintsDelay(query, countryId = 1, provider = '2gis', count = 10) {
    return delay(DELAY_FETCH_TIME).then(() => {
        return getAddressHints(query, countryId, provider, count = 10);
    });
}

/**
 * WARNING! Method is not free. Need payment
 */
export function dadataAddressCalibration(query, countryId) {
    return fetch(`${config.api.vezetvsem.url}/geo/dadata_calibration?q=${encodeURIComponent(query)}&country_id=${countryId}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .catch(error => console.error(error));
}

export function getCities(query, countryId = 1) {
    return delay(DELAY_FETCH_TIME).then(() => {
        return fetch(`${config.api.vezetvsem.url}/geo/cities/search?q=${encodeURIComponent(query)}&country_id=${countryId}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-API-KEY': config.api.vezetvsem.key,
            },
            credentials: 'same-origin',
        })
            .then(response => response.json())
            .catch(error => console.error(error));
    });
}

export function checkToken(token) {
    return fetch(`${config.api.vezetvsem.url}/onetime_token/${token}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => {
            if (response.status >= 200 && response.status < 300) {
                return response;
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        })
        .catch(error => {
            console.error(error);
            throw error;
        });
}

export function getHelpMail(mail) {
    return fetch(`${config.api.vezetvsem.url}/user/email_hint?email=${encodeURIComponent(mail)}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
    })
        .then(response => response.json())
        .catch(error => console.error(error));
}

export function getCargoNames(query, strict = false) {

    strict = strict ? 1 : 0;

    return delay(DELAY_FETCH_TIME).then(() => {
        return fetch(`${config.api.vezetvsem.url}/predefined_stuff/search?q=${encodeURIComponent(query.trim())}&limit=10&strict=${strict}`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-API-KEY': config.api.vezetvsem.key,
            },
        })
            .then(response => response.json())
            .catch(error => console.error(error));
    });
}

export function getBrands(query) {
    return delay(DELAY_FETCH_TIME).then(() => {
        return fetch(`${config.api.vezetvsem.url}/auto/search_brand?q=${encodeURIComponent(query)}&limit=10`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-API-KEY': config.api.vezetvsem.key,
            },
        })
            .then(response => response.json())
            .catch(error => console.error(error));
    });
}

export function getModels(query, brandName) {
    return delay(DELAY_FETCH_TIME).then(() => {
        return fetch(`${config.api.vezetvsem.url}/auto/search_model?q=${encodeURIComponent(query)}&brand_name=${brandName}&limit=10`, {
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-API-KEY': config.api.vezetvsem.key,
            },
        })
            .then(response => response.json())
            .catch(error => console.error(error));
    });
}

/*
export function getLocationFromYandexByCords(latitude, longitude) {
    return fetch(`https://geocode-maps.yandex.ru/1.x/?geocode=${longitude},${latitude}&format=json&apikey=${config.yandex_map.key}`, {
        method: 'get',
    })
    .then(response => response.json())
    .catch(error => console.error(error));
}
*/

/*
export function getLocationFromYandexByQuery(query) {
    return fetch(`https://geocode-maps.yandex.ru/1.x/?geocode=${encodeURIComponent(query)}&format=json&apikey=${config.yandex_map.key}`, {
        method: 'get',
    })
    .then(response => response.json())
    .catch(error => console.error(error));
}
*/

export function getLocationFromGoogleByQuery(query, provider = '2gis') {
    return fetch(`${config.api.vezetvsem.url}/geo/geocode/address?address=${encodeURIComponent(query)}&provider=${provider}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then((json) => {
            var response = json.response;
            return response;
        })
        .catch(error => console.error(error));
}

export function getLocationFromGoogleByCords(latitude, longitude, provider = '2gis') {
    return fetch(`${config.api.vezetvsem.url}/geo/geocode/addressBack?latlng=${latitude},${longitude}&provider=${provider}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then((json) => {
            var response = json.response;
            return response;
        })
        .catch(error => console.error(error));
}

export function getImgStaticMapTwoGisByCords(latitude, longitude) {
    const size   = '493x138';
    const zoom   = 16;
    const center = `${latitude},${longitude}`;

    return `https://static.maps.2gis.com/1.0?s=${size}&z=${zoom}&c=${center}&pt=${latitude},${longitude}`;
}

export function getImgStaticMapGoogleByCords(latitude, longitude) {
    return fetch(`${config.api.vezetvsem.url}/geo/static/img?lat=${latitude}&lng=${longitude}`, {
        method: 'get',
        headers: {
            'X-API-KEY': config.api.vezetvsem.key,
        },
        query: {

        }
    })
        .then((response) => response.blob())
        .then((blob) => URL.createObjectURL(blob))
        .catch(error => console.error('Ошибка при загрузке карты:', error));
}

export function getImgStaticMapGoogle(markers, path, size) {
    const markersLabels = [{ label: "A", color: "red" }, { label: "B", color: "blue" }];
    const google_markers = [];

    let markersLlabelIter = 0;

    markers.forEach((marker) => {
        google_markers.push(`markers=color:${markersLabels[markersLlabelIter].color}|label:${markersLabels[markersLlabelIter].label}|${marker[1]},${marker[0]}`);
        markersLlabelIter++;
    });

    return fetch(`${config.api.vezetvsem.url}/geo/static/img`, {
        method: 'POST',
        headers: {
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            size,
            path,
            google_markers,
        })
    })
        .then((response) => response.blob())
        .then((blob) => URL.createObjectURL(blob))
        .catch(error => console.error('Ошибка при загрузке карты:', error));
}

export function getBookingSocialUser(socialType, authData) {

    var emailQuery = '';
    if (authData.email) {
        emailQuery = `&email=${authData.email}`;
    }

    return fetch(`${config.api.vezetvsem.url}/social/booking_user?oauth_token=${authData.access_token}&social_type=${socialType}${emailQuery}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function sendRestorePassword(method, inputValue) {

    var url = '';
    var request = {};

    switch (method) {
        case 'email':
            url = `${config.api.vezetvsem.url}/user/email_restore_password`;
            request.email = inputValue;
            break;
        case 'sms':

            if (restorePasswordSMSlastTime !== null
                && Math.abs(restorePasswordSMSlastTime - new Date()) <= TIME_LIMIT_SEND_RESTORE_PASSWORD_SMS) {
                return new Promise((resolve, reject) => {
                    resolve({
                        limit: 'ONE_SMS_WITH_CODE_IN_A_MINUTE',
                    });
                })
            }

            url = `${config.api.vezetvsem.url}/user/sms_restore_password`;
            request.phone = inputValue;
            break;
        default:
            break;
    }

    return fetch(url, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            request: request,
        }),
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then((json) => {
            var response = json.response;

            if (Object.keys(response).length === 0) {
                restorePasswordSMSlastTime = new Date();
            }

            return response;
        })
        .catch(error => console.error(error));
}

export function сheckRestorePasswordCode(method, inputValue, code) {

    var url = '';
    inputValue = encodeURIComponent(inputValue);

    switch (method) {
        case 'email':
            url = `${config.api.vezetvsem.url}/user/check_email_restore_password_code?email=${inputValue}&code=${code}`;
            break;
        case 'sms':
            url = `${config.api.vezetvsem.url}/user/check_sms_restore_password_code?phone=${encodeURIComponent(inputValue)}&code=${code}`;
            break;
        default:
            break;
    }

    return fetch(url, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function setNewPasswordAfterRestore(method, newPassword, inputValue, code) {

    var request = {
        password: newPassword,
        code: code,
    };

    var url = '';

    switch (method) {
        case 'email':
            url = `${config.api.vezetvsem.url}/user/set_new_password_via_email`;
            request.email = inputValue;
            break;
        case 'sms':
            url = `${config.api.vezetvsem.url}/user/set_new_password_via_sms`;
            request.phone = inputValue;
            break;
        default:
            break;
    }

    return fetch(url, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            request: request,
        }),
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function checkVVauthorization() {
    return fetch(`${config.api.vezetvsem.url}/merchant/check_authorization`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function getOrderState(orderId, invoiceId = 0) {
    return fetch(`${config.api.vezetvsem.url}/orders/${orderId}${invoiceId > 0 ? '?invoice_id=' + invoiceId : ''}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function dumpState() {
    return fetch(`${config.api.vezetvsem.url}/booking/dump_state`, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            request: GeneralStore.getNormalizedState(),
        }),
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function sendFeedback(request, phone = '', email = '') {
    return fetch(`${config.api.vezetvsem.url}/booking/anketa`, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            request: request,
            phone: phone ? phone : '',
            email: email ? email : '',
            hash: InstantBookingStore.getHash(),
            category_name: CategoryStore.getSelected().name,
        }),
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function sendCargoPhoto(request) {
    return fetch(`${config.api.vezetvsem.url}/booking/image`, {
        method: 'post',
        headers: {
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: request,
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function removeCargoPhoto(request) {
    return fetch(`${config.api.vezetvsem.url}/booking/image/${request.index}`, {
        method: 'DELETE',
        headers: {
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            request: request,
        }),
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function getInstantPrices() {
    return InstantBookingStore.collectDataToGetPrices().then(request => {
        return fetch(`${config.api.vezetvsem.url}/booking/instant_prices`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-API-KEY': config.api.vezetvsem.key,
            },
            body: JSON.stringify({
                request: request,
            }),
            credentials: 'same-origin',
        })
            .then(response => response.json())
            .then(json => json.response)
            .catch(error => console.error(error))
    })
}

export function getServicePrices() {
    return fetch(`${config.api.vezetvsem.url}/booking/instant_prices_services`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            request: InstantBookingStore.collectDataToGetServicePrices(),
        }),
        credentials: 'same-origin',
    })
        .then((response) => response.json())
        .then((json) => json.response)
        .catch((error) => console.error(error.message))
}

export function saveInstantBookingEmail(email) {
    let prices = InstantBookingStore.getPrices()
    let bestPrice = 0

    if (prices.size > 0) {
        const bestPrices = []
        prices = prices.valueSeq()

        for (let i = 0; i < prices.size; i++) {
            const data = prices.get(i)
            if (data.date_desc.best_price === 1) {
                bestPrices.push(data)
            }

            if (bestPrices.length >= 3) {
                break
            }
        }

        if (bestPrices.length > 0) {
            let bestBestPrice = Object.values(bestPrices[0].part_day[0])[0].price
            bestPrices.forEach(data => {
                const wholeDayPriceData = Object.values(data.part_day[0])[0]

                if (bestBestPrice > wholeDayPriceData.price) {
                    bestBestPrice = wholeDayPriceData.price
                }
            })


            let bestFlexPrice = bestPrices[0].date_desc.flex_price
            bestPrices.forEach(data => {
                if (bestFlexPrice > data.date_desc.flex_price) {
                    bestFlexPrice = data.date_desc.flex_price
                }
            })

            bestPrice = bestBestPrice < bestFlexPrice ? bestBestPrice : bestFlexPrice
        }
    }

    return fetch(`${config.api.vezetvsem.url}/booking/instant_email`, {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            request: {
                email,
                hash: InstantBookingStore.getHash(),
                state_dump: GeneralStore.getNormalizedState(),
                category_name: CategoryStore.getSelected().name,
                best_price: bestPrice,
            },
        }),
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error));
}

export function fetchInstantBookingActualStateByHash(priceHash, showFullLog = false) {
    return fetch(`${config.api.vezetvsem.url}/booking/instant_prices_state?h=${priceHash}${showFullLog ? '&l=1' : ''}`, {
        method: 'get',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .catch(error => console.error(error));
}

export function submitEmailPromocode(email = '', promocode = '') {
    return fetch(`${config.api.vezetvsem.url}/merchant/check_promocode_email`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-API-KEY': config.api.vezetvsem.key,
        },
        body: JSON.stringify({
            promocode,
            email,
            source: 'instant_booking',
        }),
        credentials: 'same-origin',
    })
        .then(response => response.json())
        .then(json => json.response)
        .catch(error => console.error(error))
}



// WEBPACK FOOTER //
// ./client/api/index.js